import { render, staticRenderFns } from "./bulkprojects.vue?vue&type=template&id=018c2055&scoped=true"
import script from "./bulkprojects.vue?vue&type=script&lang=js"
export * from "./bulkprojects.vue?vue&type=script&lang=js"
import style0 from "./bulkprojects.vue?vue&type=style&index=0&id=018c2055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c2055",
  null
  
)

export default component.exports